import React from 'react';
import { FormattedMessage } from 'react-intl';

function TableHead(props) {
  return (
    <thead className="thead-light">
      <tr>
        <th
          className="day_as_timestamp"
          data-sort="day_as_timestamp"
          scope="col"
          onClick={ () => props.applySort('day_as_timestamp') }
        >
          <FormattedMessage id="components.pages.appointments.table.appointmentHolidays.start_at" />
        </th>
        <th
          className="description"
          data-sort="description"
          scope="col"
          onClick={ () => props.applySort('description') }
        >
          <FormattedMessage id="components.pages.appointments.table.appointmentHolidays.description" />
        </th>
        <th
          scope="row"
          className="w-10"
        >
          <FormattedMessage id="components.pages.management.manageOrders.table.actions" />
        </th>
      </tr>
    </thead>
  )
}

export { TableHead };
